

























import Vue from 'vue'
import Component from 'vue-class-component'
import { EPaymentReceiptType } from '@zunta/configurations'

@Component({
  name: 'Address',
  props: {
    addressType: {
      type: String,
      default: EPaymentReceiptType.ADDRESS
    },
    contact: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: true
    }
  }
})
export default class Address extends Vue {
  EPaymentReceiptType: any = EPaymentReceiptType
}
